import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY


if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!')
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
})

// Make supabase available globally for debugging (development only)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  window.supabase = supabase;
}

// Database types for better TypeScript support
export const TABLES = {
  PROFILES: 'profiles',
  QUOTES: 'quotes',
  SUBSCRIPTION_EVENTS: 'subscription_events'
}

export const QUOTE_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired'
}

export const SUBSCRIPTION_STATUS = {
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  INCOMPLETE: 'incomplete'
}

export const TIERS = {
  GOOD: 'good',
  BETTER: 'better',
  BEST: 'best'
}

// Helper function to handle Supabase errors
export const handleSupabaseError = (error) => {
  console.error('Supabase error:', error)

  const message = error?.message || String(error || '')

  if (
    message.includes('Failed to fetch') ||
    message.includes('NetworkError') ||
    message.includes('Load failed') ||
    message.includes('ENOTFOUND')
  ) {
    return 'QuoteTier cannot reach its account database right now. Please try again later or contact support if this keeps happening.'
  }
  
  if (error.code === 'PGRST301') {
    return 'Unauthorized access'
  }
  
  if (error.code === '23505') {
    return 'This record already exists'
  }
  
  return message || 'An unexpected error occurred'
}
